module.exports = __webpack_public_path__ + "img/icon_on_pulse.c598f00.png";